<template>
<div class="operating-input" @click.stop="editTaskName()">
    <div class="icon-util edit-task-icon" style="float:left;position:relative;top:2px;"></div>
    <div class="operating-input-position" id="syncName">
        <div class="task-name" v-if="!inputShow">{{value}}</div>
        <div v-if=inputShow class="edit-task">
            <input class="edit-input" v-model="value" ref="transferInput" @click.stop="" onfocus="this.select()"  @blur="submitTaskName()"/>
            <span class="task-input-icon">
                <i class="icon-util name-sure" @click.stop='submitTaskName()'></i>
                <i class="icon-util name-cancel name-cancel-position" @mousedown='cancelTaskName()'></i>
            </span>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "editInput",
    data: function () {
        return {
            oldNameValue: '',
            inputShow: false,
            value: this.inputValue
        }
    },
    props: ['submitTaskName', 'inputValue'],
    methods: {
        editTaskName() {
            let that=this;
            this.inputShow = true;
            if (this.inputValue) {
                this.oldNameValue = this.inputValue;
                
            }
            this.$nextTick(function () {
               that.$refs.transferInput.select();
            });
        },
        cancelTaskName() {
            this.inputShow = false;
            this.value = this.oldNameValue;
        },
    },
}
</script>

<style>
.edit-task {
    width: 100%;
    height: 100%;
    border: 1px solid #4181ff !important;
    /*no*/
}

.task-input-icon {
    float: right;
    position: relative;
    top: 3px;
    /*no*/
}

.edit-input {
    position: relative;
    margin: 0;
    padding-left: 5px;
    /*no*/
    height: 100%;
    font-size: 16px;
    /*no*/
    width: 125px;
    /*no*/
    border: none !important;
    color: #5562b4;
}

.operating-input-position {
    width: 180px !important;
    /*no*/
    height: 30px;
    /*no*/
    float: left;
    margin-left: 10px;
    /*no*/
    position: relative;
    top: -4px;
    /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/common/input/edit_input.vue